import React from 'react';
function AlignEndVertical({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M16.6666 16.6667H3.33325M5.99992 3.33334H7.33325C8.06963 3.33334 8.66658 3.93029 8.66658 4.66667V12.6667C8.66658 13.403 8.06963 14 7.33325 14H5.99992C5.26354 14 4.66659 13.403 4.66659 12.6667V4.66667C4.66659 3.93029 5.26354 3.33334 5.99992 3.33334ZM12.6666 8H13.9999C14.7363 8 15.3333 8.59696 15.3333 9.33334V12.6667C15.3333 13.403 14.7363 14 13.9999 14H12.6666C11.9302 14 11.3333 13.403 11.3333 12.6667V9.33334C11.3333 8.59696 11.9302 8 12.6666 8Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default AlignEndVertical;
